import React, { useState } from "react";

import { DEFAULT_PIC } from "../../../constants";
import { NO_DATA_FOUND } from "../../../constants";

import BlockPatientModal from "../../../components/uiElements/modal/BlockPatientModal";

const BlockedList = ({ patients, patientUnblock }) => {
  const [modal, setModal] = useState(false);
  const [data, setData] = useState({});
  return (
    <>
      {modal && (
        <BlockPatientModal
          isOpen={modal}
          onSuccess={() => patientUnblock(data.id)}
          closeModal={() => setModal(false)}
          label={data.patient?.first_name + data.patient?.last_name}
          type="unblock"
        />
      )}
      {patients.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="blocked">
          <table class="table mt-3">
            <thead>
              <tr className="d-flex">
                <th className="col-4">Patients</th>
                <th className="col-3">Email</th>
                <th className="col"></th>
              </tr>
            </thead>
            <tbody>
              {patients &&
                patients.map((patient, index) => {
                  return (
                    <tr key={index} className="d-flex">
                      <td className="col-4">
                        <img
                          src={patient?.patient?.image || DEFAULT_PIC}
                          width={35}
                          height={35}
                          style={{
                            borderRadius: "50%",
                          }}
                          alt={patient?.id}
                        />
                        <span className="pl-3">
                          {patient?.patient?.first_name}{" "}
                          {patient?.patient?.last_name}
                        </span>
                      </td>
                      <td className="col-3">{patient?.patient?.email}</td>
                      <td className="col " style={{ "text-align": "right" }}>
                        <u
                          className="mr-4"
                          onClick={() => {
                            setModal(true);
                            setData(patient);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Unblock
                        </u>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default BlockedList;
